<div class="sidebar h-100 overflow-auto d-flex flex-column">
  <div class="header px-4 py-3">
    <div class="mat-headline-small">Build Table</div>
  </div>
  <div class="h-100 overflow-auto">
    <div cdkDropList (cdkDropListDropped)="updateColumnPrefs($event)">
      @for (column of userColumns; track column.key) {
        <div cdkDrag class="d-flex px-3 py-2 align-items-center border-bottom">
          <div class="drag-placeholder" *cdkDragPlaceholder></div>
          <mat-checkbox [checked]="true" (change)="onColumnRemove(column)">{{ column.label }}</mat-checkbox>
          <mat-icon cdkDragHandle class="ms-auto">drag_handle</mat-icon>
        </div>
      }
    </div>
    @for (column of unselectedColumns; track column.key) {
      <div class="px-3 py-2 border-bottom">
        <mat-checkbox [checked]="false" (change)="onColumnAdd(column)">{{ column.label }}</mat-checkbox>
      </div>
    }
  </div>
</div>
